/* cart-orderbump-v2.js
 * Handles: carousel navigation, add-to-cart, coupon application, A/B mobile format.
 */

(function () {
  'use strict';

  // ── A/B mobile format ────────────────────────────────────────────────────────

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function initABFormat() {
    var root = document.querySelector('.ob-v2');
    if (!root) return;
    var configuredFormat = root.getAttribute('data-mobile-format') || 'drawer';
    if (configuredFormat !== 'ab_test') return; // fixed format, no AB needed

    var existing = getCookie('mc_format');
    var assigned = existing;
    if (!existing) {
      assigned = Math.random() < 0.5 ? 'drawer' : 'page';
      setCookie('mc_format', assigned, 30);
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'mc_format_assigned', mc_format: assigned });
      }
    }

    if (assigned === 'page' && window.innerWidth < 768) {
      // Intercept cart icon clicks — navigate to /cart instead of opening drawer
      document.addEventListener('click', function (e) {
        var target = e.target.closest('a[href="/cart"], button[aria-controls="CartDrawer"], .cart-count-bubble, [data-cart-open]');
        if (target) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = '/cart';
        }
      }, true);
    }
  }

  // ── Carousel ─────────────────────────────────────────────────────────────────

  function initCarousel(root) {
    // Skip slides hidden because their product is already in the cart
    var slides = Array.from(root.querySelectorAll('.ob-v2__slide')).filter(function (s) {
      return !s.classList.contains('ob-v2__slide--in-cart');
    });
    if (slides.length <= 1) return;

    var current = 0;
    var counter = root.querySelector('.ob-v2__nav-current');
    var total = root.querySelector('.ob-v2__nav-total');
    var btnPrev = root.querySelector('.ob-v2__nav-btn--prev');
    var btnNext = root.querySelector('.ob-v2__nav-btn--next');

    // O total vem do Liquid (ob_visible), mas reescrevo aqui porque o JS pode ter escondido
    // slides que o servidor contou — o "de N" tem de ser o N que o cliente consegue ver.
    if (total) total.textContent = String(slides.length);

    function show(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('ob-v2__slide--active', i === index);
      });
      if (counter) counter.textContent = index + 1;
      current = index;
      // Medir só depois de o slide estar visível: getBoundingClientRect num display:none
      // devolve zero, e o fitAddButton concluiria que o "+" está sozinho na linha.
      obAjustarSlide(slides[index]);
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        show((current - 1 + slides.length) % slides.length);
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        show((current + 1) % slides.length);
      });
    }

    // Touch/swipe support
    var touchStartX = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        show(diff > 0
          ? (current + 1) % slides.length
          : (current - 1 + slides.length) % slides.length
        );
      }
    }, { passive: true });
  }

  // ── Família do produto (irmãos) ──────────────────────────────────────────────
  //
  // O motor de eixos vive no global.js (cuAxisOf/cuAxisValue/cuAxisMap/cuLarguraDoSelect),
  // que o theme.liquid carrega antes desta gaveta. É reuso deliberado, não preguiça:
  // duplicar a normalização de eixos é o jeito conhecido de trocar Gola V por Gola O em
  // silêncio quando um produto da família chama o eixo "Modelo" e outro "Gola". Se por
  // qualquer motivo o global.js não estiver lá, os fallbacks abaixo mantêm o cartão
  // funcionando com casamento literal — pior, mas nunca quebra a compra.

  function obAxisOf(name) {
    if (typeof cuAxisOf === 'function') return cuAxisOf(name);
    return String(name == null ? '' : name).toLowerCase().trim();
  }

  function obAxisValue(axis, v) {
    if (typeof cuAxisValue === 'function') return cuAxisValue(axis, v);
    return String(v == null ? '' : v).toLowerCase().trim();
  }

  function obAxisMap(opts) {
    if (typeof cuAxisMap === 'function') return cuAxisMap(opts);
    var out = {};
    Object.keys(opts || {}).forEach(function (name) {
      var axis = obAxisOf(name);
      if (axis && !(axis in out)) out[axis] = opts[name];
    });
    return out;
  }

  // A variante casa nos eixos pedidos. Eixo que a variante NÃO expõe não passa: sem ele não
  // há garantia de que é a peça certa (é esse "passa direto" que troca a gola).
  function obMatches(variant, axes, axisList) {
    return axisList.every(function (axis) {
      if (!(axis in axes)) return true;
      if (!(axis in variant.axes)) return false;
      return obAxisValue(axis, variant.axes[axis]) === axes[axis];
    });
  }

  // ── Seletores de variante ────────────────────────────────────────────────────

  function fmtMoney(cents) {
    if (typeof cuMoeda === 'function') return cuMoeda(cents);
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Largura de cada campo pelo TEXTO à mostra, e a medida vai no <label> (o item de flex),
  // não no <select>. Três campos de largura igual gastam espaço no "PP" e faltam no
  // "Gola O", e era isso que empurrava o "+" pra fora da linha. Porte do sizeSelects do
  // legado; medir é COSMÉTICO, então try/catch — sem medida o `width:auto` do CSS assume.
  function obMedirCampos(selects) {
    if (typeof cuLarguraDoSelect !== 'function') return;
    try {
      selects.forEach(function (select) {
        var largura = cuLarguraDoSelect(select);
        var item = select.closest('label') || select;
        item.style.flex = '1 1 ' + largura + 'px';
        item.style.maxWidth = largura + 24 + 'px';
        select.style.width = '100%';
      });
    } catch (e) {
      /* segue sem medir */
    }
  }

  // O "+" sozinho na linha de baixo vira barra de largura cheia: um botão de 32px encostado
  // na esquerda de uma linha vazia fica órfão. Se um CAMPO desceu junto, ele continua
  // pequeno, colado no campo. Não dá em CSS — não existe seletor pra "sou o único item da
  // minha linha de flex".
  function obEncaixarBotao(slide, selects) {
    var btn = slide.querySelector('.ob-v2__add-btn');
    if (!btn || !selects.length) return;
    try {
      // Mede SEM a classe: com flex-basis:100% o botão estaria sempre sozinho na linha e a
      // medida se autoconfirmaria pra sempre, inclusive depois de a gaveta alargar.
      btn.classList.remove('ob-v2__cta--full');
      var topo = btn.getBoundingClientRect().top;
      var acompanhado = selects.some(function (select) {
        var item = select.closest('label') || select;
        return Math.abs(item.getBoundingClientRect().top - topo) < 4;
      });
      if (!acompanhado) btn.classList.add('ob-v2__cta--full');
    } catch (e) {
      /* sem medida o botão fica pequeno, que é o padrão do CSS */
    }
  }

  function obAjustarSlide(slide) {
    if (!slide) return;
    var selects = Array.prototype.slice.call(slide.querySelectorAll('.ob-v2__option-select'));
    if (!selects.length) return;
    obMedirCampos(selects);
    obEncaixarBotao(slide, selects);
  }

  function initVariantSelectors(root) {
    root.querySelectorAll('.ob-v2__slide').forEach(function (slide) {
      var jsonEl = slide.querySelector('.ob-v2__variants-json');
      var selects = Array.prototype.slice.call(slide.querySelectorAll('.ob-v2__option-select'));
      if (!jsonEl) return;

      var raw;
      try { raw = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      if (!Array.isArray(raw) || !raw.length) return;

      // Cada variante da família já vem com pid/handle do produto a que pertence e as opções
      // por nome; aqui só derivo o mapa de eixos normalizado uma vez.
      var variants = raw.map(function (v) {
        return {
          id: v.id,
          pid: v.pid,
          handle: v.handle,
          available: !!v.available,
          price: v.price,
          compare_at_price: v.compare_at_price,
          image: v.image,
          axes: obAxisMap(v.opts),
        };
      });

      var btn = slide.querySelector('.ob-v2__add-btn');
      var priceEl = slide.querySelector('.ob-v2__price-sale');
      var compareEl = slide.querySelector('.ob-v2__price-original');
      var imgEl = slide.querySelector('.ob-v2__img');
      var defaultImgSrc = imgEl ? imgEl.src : null;
      var discountPct = parseFloat(slide.getAttribute('data-discount-percentage')) || 0;
      var pixPct = parseFloat(slide.getAttribute('data-pix-discount')) || 0;

      function selectedAxes() {
        var out = {};
        selects.forEach(function (select) {
          var axis = obAxisOf(select.getAttribute('data-option-name'));
          if (axis) out[axis] = obAxisValue(axis, select.value);
        });
        return out;
      }

      function primeiro(pred) {
        var achado = null;
        variants.some(function (v) { if (pred(v)) { achado = v; return true; } return false; });
        return achado;
      }

      function findVariant(axes) {
        var all = Object.keys(axes);
        // Disponível primeiro: a MESMA combinação pode existir em mais de um irmão.
        return primeiro(function (v) { return v.available && obMatches(v, axes, all); })
          || primeiro(function (v) { return obMatches(v, axes, all); });
      }

      // Relaxa os eixos até achar peça com estoque: [cor+gola], depois [cor], depois
      // qualquer uma. Sem isto, escolher uma cor que só existe noutra gola deixava o
      // cartão morto — o cliente clicava em "Vinho" e o "+" apagava, porque o tamanho e a
      // gola herdados da cor anterior não existem nessa peça.
      function findAvailableVariant(axes) {
        return primeiro(function (v) { return v.available && obMatches(v, axes, ['cor', 'gola']); })
          || primeiro(function (v) { return v.available && obMatches(v, axes, ['cor']); })
          || primeiro(function (v) { return v.available; });
      }

      // O valor da variante pode não ser LITERALMENTE igual ao do <option> (um produto da
      // família escreve "Gola O", outro escreve "O"): acha pelo valor normalizado do eixo.
      function escreverSelect(select, axis, raw) {
        var want = obAxisValue(axis, raw);
        var match = Array.prototype.find.call(select.options, function (o) {
          return obAxisValue(axis, o.value) === want;
        });
        if (match) select.value = match.value;
      }

      // Risca e escreve "(Esgotado)" no valor sem peça disponível, sem desabilitar — mesma
      // convenção da PDP. A COR é avaliada SOZINHA (é o que o cliente usa pra ver a foto);
      // os outros eixos, contra a combinação inteira, senão "Mescla / XXGG / Gola V" passa
      // batido por existir XXGG em Mescla noutra gola.
      function marcarEsgotados() {
        var axes = selectedAxes();
        selects.forEach(function (select) {
          var axis = obAxisOf(select.getAttribute('data-option-name'));
          if (!axis) return;
          Array.prototype.forEach.call(select.options, function (opt) {
            if (opt.dataset.label == null) opt.dataset.label = opt.textContent;
            var probe = Object.assign({}, axes);
            probe[axis] = obAxisValue(axis, opt.value);
            var scope = axis === 'cor' ? ['cor'] : Object.keys(probe);
            var temEstoque = variants.some(function (v) {
              return v.available && obMatches(v, probe, scope);
            });
            opt.textContent = temEstoque ? opt.dataset.label : opt.dataset.label + ' (Esgotado)';
            opt.classList.toggle('is-out-of-stock', !temEstoque);
          });
        });
      }

      // `permitirFallback` decide se os OUTROS eixos podem ceder. Verdadeiro na montagem
      // (a oferta nunca nasce travada em "Esgotado") e quando a COR muda — trocar de cor
      // pode trocar de produto, e o irmão nem sempre tem os mesmos tamanhos/golas.
      // Falso quando o cliente mexe em tamanho ou gola: aí a escolha dele manda e ele vê
      // o "Esgotado", em vez de ser movido em silêncio pra outra peça. Mesma regra do
      // legado (global.js, attachVariantListeners).
      function update(permitirFallback) {
        var axes = selectedAxes();
        var matched = findVariant(axes);

        if (permitirFallback && selects.length && (!matched || !matched.available)) {
          var fallback = findAvailableVariant(axes);
          if (fallback) {
            matched = fallback;
            // Escreve de volta nos campos a combinação que existe de verdade.
            selects.forEach(function (select) {
              var axis = obAxisOf(select.getAttribute('data-option-name'));
              if (axis && fallback.axes[axis] != null) escreverSelect(select, axis, fallback.axes[axis]);
            });
          }
        }

        if (!matched) {
          if (btn) btn.disabled = true;
          slide.classList.add('ob-v2__slide--unavailable');
          return;
        }

        if (btn) {
          btn.setAttribute('data-variant-id', String(matched.id));
          // O produto pode ser um IRMÃO: o add tem de mirar a peça escolhida, não a variante
          // do produto base. `handle` some pra o resolveVariantId não voltar a buscar pelo
          // handle do produto da oferta e desfazer a escolha do cliente.
          btn.setAttribute('data-product-handle', '');
          if (matched.pid != null) {
            btn.setAttribute('data-product-id', 'gid://shopify/Product/' + matched.pid);
          }
          btn.disabled = !matched.available;
        }
        slide.classList.toggle('ob-v2__slide--unavailable', !matched.available);

        if (priceEl && matched.price != null) {
          var salePrice = discountPct > 0
            ? Math.round(matched.price * (1 - discountPct / 100))
            : matched.price;
          // Mesma conta do Liquid: o preço "no Pix" é o da oferta menos a % de Pix do
          // tema (data-pix-discount). Sem o atributo cai em 0% — nunca inventa desconto.
          if (pixPct > 0) salePrice = Math.round(salePrice * (1 - pixPct / 100));
          priceEl.textContent = fmtMoney(salePrice);
        }
        if (compareEl) {
          var origPrice = discountPct > 0
            ? matched.price
            : (matched.compare_at_price && matched.compare_at_price > matched.price ? matched.compare_at_price : null);
          if (origPrice) {
            compareEl.textContent = fmtMoney(origPrice);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        // Irmão tem foto própria: sem trocar aqui, escolher a cor de um irmão deixava a foto
        // do produto base no cartão.
        if (imgEl) imgEl.src = matched.image || defaultImgSrc || '';
      }

      if (!selects.length) {
        // Produto de variante única: nada a escolher, mas o "+" ainda precisa da variante.
        update(true);
        return;
      }

      selects.forEach(function (select) {
        var eixoDoCampo = obAxisOf(select.getAttribute('data-option-name'));
        select.addEventListener('change', function () {
          // update PRIMEIRO: é ele que pode reescrever os campos pelo fallback, e marcar
          // esgotados antes disso rotularia a combinação antiga.
          update(eixoDoCampo === 'cor');
          marcarEsgotados();
          // E medir por último: o "(Esgotado)" decide o texto à mostra, o texto decide a
          // largura do campo, e a largura decide se o "+" ainda cabe na linha.
          obAjustarSlide(slide);
        });
      });

      // Montagem com fallback: sem interação do cliente ainda, a oferta não pode nascer
      // travada em "Esgotado" só porque a primeira combinação do servidor acabou.
      update(true);
      marcarEsgotados();
      obAjustarSlide(slide);
    });
  }

  // ── Condition monitoring ─────────────────────────────────────────────────────

  // Modelo de unidades (espelha o Liquid e a extensão de checkout): cada produto gatilho é uma
  // unidade; a coleção, se houver, é UMA unidade (algum item do carrinho pertence a ela, via os
  // GIDs vindos do blob .ob-v2__collection-pids-json); a lista de combos, se houver, é UMA unidade
  // (alguma linha carrega `_combo_id` de um deles). operator OR = qualquer unidade; senão (E) =
  // todas. Valor mín/máx sempre aplicado. Caminho de limpeza: na dúvida (sem GIDs da coleção), não
  // conta a unidade-coleção para evitar remoção indevida.
  //
  // O combo entrou com as campanhas (ob-v2-condicoes): sem ele aqui, uma oferta "produto X OU
  // combo Y" aceita por causa do combo era REMOVIDA do carrinho, porque a única unidade que este
  // código enxergava (o produto X) não estava lá.
  function evaluateConditions(cond, cart) {
    if (!cond) return true;
    var cartCents = cart.total_price;

    if (cond.min_cart_value) {
      if (cartCents < cond.min_cart_value * 100) return false;
    }
    if (cond.max_cart_value) {
      if (cartCents > cond.max_cart_value * 100) return false;
    }

    var cartGids = cart.items.map(function (item) {
      return 'gid://shopify/Product/' + item.product_id;
    });

    var units = [];
    var tids = cond.trigger_product_ids;
    if (tids && tids.length > 0) {
      tids.forEach(function (tid) { units.push(cartGids.indexOf(tid) !== -1); });
    }
    var colPids = cond.trigger_collection_product_ids;
    if (cond.trigger_collection_handle && Array.isArray(colPids)) {
      units.push(cartGids.some(function (g) { return colPids.indexOf(g) !== -1; }));
    }
    var combos = Array.isArray(cond.trigger_combo_ids)
      ? cond.trigger_combo_ids.map(function (c) { return String(c == null ? '' : c).trim(); })
      : [];
    if (combos.length > 0) {
      units.push(cart.items.some(function (item) {
        var cid = String((item.properties || {})._combo_id || '').trim();
        return cid !== '' && combos.indexOf(cid) !== -1;
      }));
    }

    if (units.length === 0) return true;
    if (cond.operator === 'OR') {
      return units.some(function (u) { return u; });
    }
    return units.every(function (u) { return u; });
  }

  var isAdjustingBump = false;

  function checkBumpConditions(cart) {
    if (isAdjustingBump) return;
    var root = document.querySelector('.ob-v2');
    if (!root) return;

    root.querySelectorAll('.ob-v2__slide').forEach(function (slide) {
      var bumpGid = slide.getAttribute('data-product-id');
      if (!bumpGid) return;
      var numericId = bumpGid.replace('gid://shopify/Product/', '');

      var bumpLine = cart.items.find(function (item) {
        return String(item.product_id) === numericId;
      });
      if (!bumpLine) return;

      var condEl = slide.querySelector('.ob-v2__conditions-json');
      if (!condEl) return;
      var cond;
      try { cond = JSON.parse(condEl.textContent); } catch (e) { return; }

      // GIDs dos produtos da coleção gatilho (blob renderizado pelo Liquid), p/ a unidade-coleção.
      var pidsEl = slide.querySelector('.ob-v2__collection-pids-json');
      if (pidsEl) {
        try { cond.trigger_collection_product_ids = JSON.parse(pidsEl.textContent); } catch (e) { /* ignore */ }
      }

      if (!evaluateConditions(cond, cart)) {
        var bumpCoupon = slide.getAttribute('data-coupon') || '';
        isAdjustingBump = true;

        var removeProduct = fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: bumpLine.key, quantity: 0 }),
        });

        var removeDiscount = bumpCoupon
          ? fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (c) {
                var remaining = (c.discount_codes || [])
                  .filter(function (dc) { return dc.code.toUpperCase() !== bumpCoupon.toUpperCase(); })
                  .map(function (dc) { return dc.code; })
                  .join(',');
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                  body: JSON.stringify({ discount: remaining }),
                });
              })
              .catch(function () { /* silent */ })
          : Promise.resolve();

        Promise.all([removeProduct, removeDiscount])
          .then(function () { return refreshCartDrawer(); })
          .then(function () {
            isAdjustingBump = false;
            var feedbackRoot = document.querySelector('.ob-v2') || root;
            showFeedback(feedbackRoot, 'Oferta removida: condições não são mais válidas.', false);
          })
          .catch(function () { isAdjustingBump = false; });
      }
    });
  }

  // ── BUMP_ sem âncora ─────────────────────────────────────────────────────────
  //
  // O cupom BUMP_ (do mini cart ou do checkout) só vale com outro produto que o cliente pôs
  // por fora — linha sem as marcas do bump. Sem ele a Function já não desconta, mas o código
  // ficava no carrinho valendo R$ 0 e voltava a valer se o cliente pusesse algo de novo. Tira
  // o código, como o checkout faz (extensão orderbump, temAncora).
  var OB_MAX_FALHAS_ANCORA = 3;
  var obFalhasAncora = 0;

  function obLinhaDeBump(item) {
    var p = item.properties || {};
    return String(p._moon_ob_item || '') === 'true' || String(p._moon_ob_coupon || '').trim() !== '';
  }

  function obTirarBumpSemAncora(cart) {
    if (!cart || obFalhasAncora >= OB_MAX_FALHAS_ANCORA) return Promise.resolve(false);
    var codes = (cart.discount_codes || []).map(function (dc) { return dc.code || ''; });
    var bumps = codes.filter(function (c) { return c.toUpperCase().indexOf('BUMP_') === 0; });
    if (bumps.length === 0) return Promise.resolve(false);
    var temAncora = (cart.items || []).some(function (item) {
      return (item.quantity || 0) > 0 && !obLinhaDeBump(item);
    });
    if (temAncora) return Promise.resolve(false);

    var resto = codes.filter(function (c) { return bumps.indexOf(c) === -1; }).join(',');
    isAdjustingBump = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: resto }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update ' + r.status);
        obFalhasAncora = 0;
        return refreshCartDrawer();
      })
      .then(function () { return true; })
      .catch(function () { obFalhasAncora += 1; return false; })
      .then(function (tirou) { isAdjustingBump = false; return tirou; });
  }

  var conditionCheckTimer = null;

  function scheduleConditionCheck() {
    clearTimeout(conditionCheckTimer);
    conditionCheckTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return obTirarBumpSemAncora(cart).then(function (tirou) {
            if (!tirou) checkBumpConditions(cart);
          });
        })
        .catch(function () { /* silent */ });
    }, 300);
  }

  function watchCartChanges() {
    var cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) return;
    var observer = new MutationObserver(function () {
      if (!isAdjustingBump) scheduleConditionCheck();
    });
    observer.observe(cartDrawer, { childList: true, subtree: false });
  }

  // ── Exclusividade: onde o V2 aparece, o legado não aparece ───────────────────
  //
  // O Liquid já decide isso numa conta só (ob-v2-assume-pagina, usada pelos dois
  // snippets), então em render normal o legado nem chega ao HTML. Este é o cinto: a
  // gaveta é re-renderizada por fetch a cada mutação do carrinho, e HTML de uma versão
  // anterior do tema — ou de qualquer caminho que não passe pelos dois snippets — pode
  // trazer os dois blocos juntos. Aí o cliente vê as ofertas do V2 misturadas com as do
  // legado no mesmo carrossel, que foi o sintoma reportado.
  //
  // Esconde, não remove: o <custom-cart-upsell> é um custom element, e arrancar o nó
  // dispara disconnected/connectedCallback (o comentário do sola-main-product conta que
  // reinicializar duplicava os ouvintes de clique e o botão fazia dois adds).
  function obGarantirExclusividade() {
    if (!document.querySelector('.ob-v2')) return;
    document.querySelectorAll('#cart-upsell-original').forEach(function (legado) {
      if (legado.hasAttribute('data-ob-v2-suprimido')) return;
      legado.setAttribute('data-ob-v2-suprimido', '1');
      legado.hidden = true;
    });
  }

  // ── Recolher / expandir ──────────────────────────────────────────────────────
  //
  // Chave PRÓPRIA, separada do legado (moon_cart_upsell_collapsed): são dois blocos
  // diferentes, e nas páginas em escopo o cliente vê só o V2. Compartilhar a chave faria
  // recolher um deles recolher o outro numa página onde ele nem aparece.
  //
  // Delegado em document porque a gaveta inteira é reconstruída a cada atualização do
  // carrinho — assim não é preciso reanexar o listener depois de cada render.

  var OB_COLLAPSE_KEY = 'moon_ob_v2_collapsed';

  // Celular, mesma regra do legado (applyCartUpsellCollapsedState, global.js): com 3+
  // linhas no carrinho a lista de produtos já ocupa a tela, então o bloco abre RECOLHIDO;
  // com até 2, abre aberto. Se o cliente abrir/fechar na mão, a escolha vale enquanto o
  // nº de linhas não mudar (sessionStorage, chave própria: não mexe no computador).
  var OB_MOBILE_KEY = 'moon_ob_v2_mobile';
  var obMobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function obLinhas(root) {
    var n = parseInt(root && root.getAttribute('data-cart-lines'), 10);
    return isNaN(n) ? null : n;
  }

  function obNoCelular(root) {
    return !!(obMobileQuery && obMobileQuery.matches && obLinhas(root) !== null);
  }

  function obLerRecolhido(root) {
    if (obNoCelular(root)) {
      var linhas = obLinhas(root);
      try {
        var salvo = JSON.parse(sessionStorage.getItem(OB_MOBILE_KEY) || 'null');
        if (salvo && salvo.lines === linhas) return salvo.collapsed === true;
      } catch (e) { /* segue na regra */ }
      return linhas >= 3;
    }
    try { return localStorage.getItem(OB_COLLAPSE_KEY) === 'true'; } catch (e) { return false; }
  }

  function obGravarRecolhido(v, root) {
    if (obNoCelular(root)) {
      try { sessionStorage.setItem(OB_MOBILE_KEY, JSON.stringify({ lines: obLinhas(root), collapsed: v })); } catch (e) { /* modo privado */ }
      return;
    }
    try { localStorage.setItem(OB_COLLAPSE_KEY, String(v)); } catch (e) { /* modo privado */ }
  }

  function obRotularToggle(botao, recolhido) {
    botao.setAttribute('aria-expanded', String(!recolhido));
    botao.setAttribute('aria-label', recolhido ? 'Expandir ofertas' : 'Recolher ofertas');
  }

  function obAplicarRecolhido(root) {
    var recolhido = obLerRecolhido(root);
    root.classList.toggle('ob-v2--collapsed', recolhido);
    var botao = root.querySelector('.ob-v2__strip-label');
    if (botao) obRotularToggle(botao, recolhido);
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest('.ob-v2__strip-label');
    if (!botao) return;
    var root = botao.closest('.ob-v2');
    if (!root) return;
    e.preventDefault();
    var recolhido = root.classList.toggle('ob-v2--collapsed');
    obGravarRecolhido(recolhido, root);
    obRotularToggle(botao, recolhido);
    // Ao reabrir, os campos estavam em display:none e nunca foram medidos.
    if (!recolhido) obAjustarSlide(root.querySelector('.ob-v2__slide--active'));
  });

  // ── Add to cart + coupon ──────────────────────────────────────────────────────

  function showFeedback(root, message, isError) {
    var el = root.querySelector('.ob-v2__feedback');
    if (!el) return;
    el.textContent = message;
    el.style.display = 'block';
    el.style.color = isError ? '#c00' : '#008060';
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.style.display = 'none'; }, 4000);
  }

  function resolveVariantId(btn) {
    // 1. Variant ID explícito configurado no admin — usar diretamente
    var variantId = btn.getAttribute('data-variant-id');
    if (variantId && variantId.trim() !== '') {
      return Promise.resolve(variantId.replace('gid://shopify/ProductVariant/', ''));
    }

    // 2. Buscar pelo handle via /products/HANDLE.json (endpoint Storefront confiável)
    //    NÃO usar /products.json?ids= — esse endpoint ignora o filtro e retorna todos os produtos
    var handle = btn.getAttribute('data-product-handle') || '';
    if (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var product = data.product;
          if (!product || !product.variants || !product.variants[0]) {
            throw new Error('Produto não encontrado');
          }
          var variant = product.variants.find(function (v) { return v.available; })
            || product.variants[0];
          return String(variant.id);
        });
    }

    return Promise.reject(new Error('Handle do produto não configurado. Selecione o produto novamente no admin.'));
  }

  function addToCart(variantNumericId, coupon, campanha) {
    // `_moon_ob_item` marca TODA linha do bump, com cupom ou sem: o cupom BUMP_ só vale com
    // outro produto que o cliente pôs por fora, e o checkout (extensão orderbump, temAncora)
    // precisa saber que esta linha não é "por fora". Mesma property do bloco do checkout.
    //
    // `_moon_origem` e `_moon_campanha` dizem DE ONDE a venda veio (o carrinho lateral, e qual
    // campanha estava no ar), com cupom ou sem — é o que deixa o relatório atribuir o pedido à
    // campanha. Só leitura: nenhuma Function depende delas. `_moon_campanha` só sai quando há
    // campanha (config em formato de campanhas, data-campanha no .ob-v2); vazia não diria nada.
    var props = { _moon_ob_item: 'true', _moon_origem: 'mini_cart' };
    if (campanha && campanha.trim() !== '') props._moon_campanha = campanha.trim();
    var payload = { id: variantNumericId, quantity: 1, properties: props };
    // Property oculta liga a linha ao cupom BUMP_: a function cart-discount-rules
    // desconta apenas a linha marcada (outras variantes do produto ficam sem desconto).
    if (coupon && coupon.trim() !== '') {
      payload.properties._moon_ob_coupon = coupon.trim().toUpperCase();
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Erro ao adicionar'); });
      return r.json();
    });
  }

  function obCarrinho() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  function obTemCodigo(cart, code) {
    return (cart.discount_codes || []).some(function (dc) {
      return (dc.code || '').toUpperCase() === code.toUpperCase();
    });
  }

  /**
   * Aplica o cupom e CONFERE que ele entrou. Devolve o carrinho final.
   *
   * A conferência é o ponto: antes esta função ignorava a resposta e o cartão dizia
   * "Desconto de 20% aplicado" mesmo quando o código não entrava — a falha ficava
   * invisível e o cliente ia pro checkout sem desconto.
   *
   * Dois caminhos, nesta ordem:
   *  1. `/cart/update.js` com `discount` — é o que o widget já usava.
   *  2. `/discount/<CODE>` — a rota de storefront que a Shopify expõe pra aplicar código.
   *     Entra só se (1) não colar. Custa uma requisição a mais no caminho de exceção e
   *     resolve o caso de (1) não ser suportado.
   *
   * Se nenhum dos dois colar, devolve o carrinho e quem chamou avisa o cliente com a
   * verdade, em vez de anunciar um desconto que não existe.
   */
  function applyCoupon(coupon) {
    if (!coupon || coupon.trim() === '') return Promise.resolve(null);
    var code = coupon.trim();

    return obCarrinho()
      .then(function (cart) {
        if (obTemCodigo(cart, code)) return cart;

        var todos = (cart.discount_codes || [])
          .map(function (dc) { return dc.code; })
          .concat([code])
          .join(',');

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ discount: todos }),
        })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; })
          .then(function (depois) {
            if (depois && obTemCodigo(depois, code)) return depois;
            // Não colou: tenta a rota de desconto do storefront.
            return fetch('/discount/' + encodeURIComponent(code), {
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
              .catch(function () { /* segue pra conferência */ })
              .then(obCarrinho)
              .catch(function () { return depois || cart; });
          });
      })
      .catch(function () { return null; });
  }

  function handleAddClick(e) {
    var btn = e.target.closest('.ob-v2__add-btn');
    if (!btn) return;
    var root = btn.closest('.ob-v2');
    if (!root) return;

    var coupon = btn.getAttribute('data-coupon') || '';
    var campanha = root.getAttribute('data-campanha') || '';
    var slide = btn.closest('.ob-v2__slide');
    var discountPct = parseFloat((slide && slide.getAttribute('data-discount-percentage')) || '0') || 0;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '...';

    var cupomEntrou = null; // null = nao havia cupom a aplicar

    resolveVariantId(btn)
      .then(function (variantId) { return addToCart(variantId, coupon, campanha); })
      .then(function () {
        if (!coupon.trim()) return null;
        return applyCoupon(coupon).then(function (cart) {
          // Guarda o VEREDITO, nao a promessa de que tentamos: e ele que decide a
          // mensagem. `cart` nulo = nao deu pra conferir; trata como nao aplicado, porque
          // anunciar desconto sem certeza e o erro que se quer evitar.
          cupomEntrou = !!(cart && obTemCodigo(cart, coupon.trim()));
          return cart;
        });
      })
      .then(function () {
        // Mesmo evento do widget legado (cart_upsell_add_to_cart), com os mesmos campos:
        // o V2 substitui o legado nas páginas em escopo, e sem isto o funil do GTM perdia
        // o add do carrinho exatamente na campanha que se quer medir. productId é o do
        // IRMÃO escolhido quando houver, senão a % de conversão seria atribuída ao produto
        // base no relatório.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'cart_upsell_add_to_cart',
          productId: btn.getAttribute('data-product-id'),
          productName: btn.getAttribute('data-product-name'),
          variantId: btn.getAttribute('data-variant-id'),
        });
      })
      .then(function () { return refreshCartDrawer(); })
      .then(function () {
        var msg, erro = false;
        if (cupomEntrou === false) {
          // Produto entrou, desconto nao. Dizer isso e melhor que anunciar um desconto que
          // o checkout nao vai dar — e e o unico jeito de alguem descobrir a tempo.
          msg = 'Produto adicionado, mas o desconto não foi aplicado.';
          erro = true;
          if (window.console && console.warn) {
            console.warn('[ob-v2] cupom ' + coupon.trim() + ' nao entrou no carrinho. ' +
              'Confira se o desconto existe no admin e se o produto nao tem tag ' +
              'desconto-no-preco/nocupom (a Function exclui esses do cupom).');
          }
        } else if (cupomEntrou === true && discountPct > 0) {
          msg = 'Adicionado! Desconto de ' + discountPct + '% aplicado.';
        } else {
          msg = 'Produto adicionado!';
        }
        showFeedback(root, msg, erro);
        btn.textContent = 'Adicionado ✓';
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2500);
      })
      .catch(function (err) {
        showFeedback(root, err.message || 'Erro ao adicionar.', true);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  function refreshCartDrawer() {
    // Re-renderiza a secao da gaveta NA URL DA PAGINA ATUAL, nao em '/'. O escopo do
    // V2 (ob-v2-escopo-pagina) le `page.handle`; renderizando em '/' ele vem vazio, a
    // oferta cai fora de escopo e a gaveta re-renderizada volta com o LEGADO — era isso
    // que fazia o V2 "sumir do carrinho" a cada mutacao. Mesmo principio do
    // `sections_url: window.location.pathname` que o cart.js ja usa no add.
    var sectionId = 'cart-drawer';
    return fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('#CartDrawer');
        var existingSection = document.querySelector('#CartDrawer');
        if (newSection && existingSection) {
          existingSection.innerHTML = newSection.innerHTML;
          // Re-init the order bump carousel after re-render
          init();
        }
      });
  }

  // ── Init ─────────────────────────────────────────────────────────────────────

  function initRoot(root) {
    if (!root || root.__obV2Init) return;
    root.__obV2Init = true;
    obGarantirExclusividade();
    initCarousel(root);
    initVariantSelectors(root);
    obAplicarRecolhido(root);
    // Carrossel de uma oferta só: o initCarousel sai antes de medir, então mede aqui.
    obAjustarSlide(root.querySelector('.ob-v2__slide--active'));
    root.addEventListener('click', handleAddClick);
  }

  var obWatchingDrawer = false;
  var obInitAncora = false;

  function init() {
    initRoot(document.querySelector('.ob-v2'));
    watchCartChanges();
    // Carrinho que já chega sem âncora (o cliente tirou o produto em outra aba ou voltou do
    // checkout): sem mutação na gaveta, só a carga da página percebe.
    if (!obInitAncora) {
      obInitAncora = true;
      obCarrinho().then(obTirarBumpSemAncora).catch(function () { /* silent */ });
    }
    // A gaveta troca o innerHTML a cada add/remove/quantidade e o .ob-v2 novo chega sem
    // carrossel, sem campos medidos e sem o estado de recolhido — o legado resolve o
    // mesmo problema com um MutationObserver (global.js). Um nó novo = um init novo.
    var drawer = document.getElementById('CartDrawer');
    if (drawer && !obWatchingDrawer && window.MutationObserver) {
      obWatchingDrawer = true;
      new MutationObserver(function () {
        var root = document.querySelector('.ob-v2');
        if (root && !root.__obV2Init) initRoot(root);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initABFormat();
    init();
  });

  // Re-init after Shopify section re-renders (triggered by cart updates)
  document.addEventListener('shopify:section:load', function () {
    init();
  });

})();
